import Cookie from 'js-cookie';
import { parseVisitorId, isArray } from '@grandvisionhq/utils';
import { AlgoliaEventType, AlgoliaAnalyticsEvents } from './types.js';

const getVisitorId = ()=>{
    const visitorCookie = Cookie.get('_visitor');
    if (!visitorCookie) {
        return Cookie.get('_ALGOLIA') // use the fallback user token provided by algolia
        ;
    }
    const visitorId = parseVisitorId(visitorCookie);
    if (visitorId !== undefined && typeof visitorId !== 'string') {
        return visitorId.id;
    }
    return visitorId;
};
const clickedObjectIds = (eventData)=>{
    const algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    const { objectIds , searchIndex , eventName  } = eventData;
    if (algoliaAnalyticsHandler) {
        algoliaAnalyticsHandler(AlgoliaEventType.Click, {
            userToken: getVisitorId(),
            objectIDs: isArray(objectIds) ? objectIds : [
                objectIds
            ],
            index: searchIndex,
            eventName
        });
    }
};
const handleConversionEvent = (eventData)=>{
    const algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    const { objectIds , searchIndex , queryId  } = eventData;
    const visitorId = getVisitorId();
    if (!visitorId) {
        return;
    }
    if (algoliaAnalyticsHandler && searchIndex && objectIds) {
        const eventData = {
            userToken: visitorId,
            index: searchIndex,
            queryID: queryId,
            eventName: AlgoliaAnalyticsEvents.ProductDetailCTAClicked,
            objectIDs: Array.isArray(objectIds) ? objectIds : [
                objectIds
            ]
        };
        const type = eventData.queryID ? AlgoliaEventType.ConversionAfterSearch : AlgoliaEventType.Conversion;
        algoliaAnalyticsHandler(type, eventData);
    }
};
const clickedObjectIdsAfterSearch = (eventData)=>{
    const algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    const { searchIndex , positions , objectIds , eventName , queryId  } = eventData;
    if (!positions || !objectIds) {
        console.warn('Algolia analytics event could not be sent! eventData:', eventData);
        return;
    }
    if (algoliaAnalyticsHandler) {
        algoliaAnalyticsHandler(AlgoliaEventType.ClickAfterSearch, {
            eventName,
            queryID: queryId,
            objectIDs: isArray(objectIds) ? objectIds : [
                objectIds
            ],
            positions: isArray(positions) ? positions : [
                positions
            ],
            index: searchIndex,
            userToken: getVisitorId()
        });
    }
};
const getAlgoliaAnalyticsHandler = ()=>{
    if (typeof window !== undefined && window.aa) {
        return window.aa;
    }
    return undefined;
};

export { clickedObjectIds, clickedObjectIdsAfterSearch, getAlgoliaAnalyticsHandler, getVisitorId, handleConversionEvent };
//# sourceMappingURL=AlgoliaAnalyticsHelpers.js.map
